module.exports = __webpack_public_path__ + "img/be.0dec981f.svg";